// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5abbbf23","498":"4cc3bd75","703":"8f51f122"}[chunkId] + ".chunk.js";
};